import { creatorbase } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';
import type { ColumnDef, CellContext as LibCellContext } from '@tanstack/react-table';
import { tableHelpers } from '@round/creatorbase-ui';

export const PAGE_SIZE = 25;

export type PoolRow = creatorbase.Pool & { createdBy: creatorbase.User | null };

export type Meta = {
    isLoading: boolean;
    hasError?: boolean;
    getIsUserLoading: (row: PoolRow) => boolean;
};

export const getMeta = getTableMetaHelper<Meta>();

export type CellContext = LibCellContext<tableHelpers.WithLoadingRow<PoolRow>, unknown>;

// `any` (not `unknown`) so string-valued cells like tableHelpers.TruncatedCell,
// whose context is typed to a string value, satisfy the shared column type.
export type Column = ColumnDef<tableHelpers.WithLoadingRow<PoolRow>, any>;
